export default "__VITE_ASSET__BMfJ6m52__"